// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
export let InitDataRequest = function (fieldSet)
{
    this.Code = Message.CODE_INIT_DATA_REQUEST;
    PFixMessage.call(this, fieldSet);
}
InitDataRequest.prototype = Object.create(PFixMessage.prototype);

InitDataRequest.prototype.getMaxFieldNumber = function ()
{
    let FIELD_MAX_PFIX_FIELD_INDEX = this.FieldSet.GetField(FieldsFactory.FIELD_MAX_PFIX_FIELD_INDEX);
    if (FIELD_MAX_PFIX_FIELD_INDEX)
        return FIELD_MAX_PFIX_FIELD_INDEX.Value;
    else
        return 2147483647// int.MaxValue;
}
InitDataRequest.prototype.setMaxFieldNumber = function (number)
{
    this.setFieldValue(FieldsFactory.FIELD_MAX_PFIX_FIELD_INDEX, number);
}